import { useLearningOpportunitiesOptionsQuery } from './use-learning-opportunities-options-query';

export const useLearningOpportunitiesPermissions = (): {
    readonly canUserCreateLearningOpportunities: boolean;
    readonly canUserFilterLearningOpportunities: boolean;
    readonly canUserRecommendLearningOpportunities: boolean;
    readonly canUserSeeLearningOpportunities: boolean;
    readonly isPending: boolean;
} => {
    const { data: options, isPending } = useLearningOpportunitiesOptionsQuery();

    const canUserSeeLearningOpportunities = options?.canManageLearningOpportunities ?? false;
    const canUserCreateLearningOpportunities = options?.canCreateLearningOpportunities ?? false;
    const canUserFilterLearningOpportunities = options?.canManageLearningOpportunities ?? false;
    const canUserRecommendLearningOpportunities = options?.canGetRecommendedLearningOpportunities ?? false;

    return {
        canUserCreateLearningOpportunities,
        canUserFilterLearningOpportunities,
        canUserRecommendLearningOpportunities,
        canUserSeeLearningOpportunities,
        isPending,
    };
};
